/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1LocationCountriesDropdown200,
  GetApiV1LocationCountriesDropdown401,
  GetApiV1LocationCountriesDropdown500,
  GetApiV1LocationCountriesDropdownQueryResponse,
} from "../../types/locationCountryController/GetApiV1LocationCountriesDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1LocationCountriesDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1LocationCountriesDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1LocationCountriesDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCountriesDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1LocationCountriesDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCountriesDropdown500>;

export const getApiV1LocationCountriesDropdownQueryResponseSchema = z.lazy(
  () => getApiV1LocationCountriesDropdown200Schema,
) as unknown as ToZod<GetApiV1LocationCountriesDropdownQueryResponse>;
